import { Injectable } from '@angular/core';
import { firstValueFrom, of } from 'rxjs';
import { catchError, map, tap, timeout } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { SessionStorageService } from '../../shared-services/services/session-storage.service';
import { RawB2cToken } from '../models/raw-bwc-token.model';
import { GetUrlRequest } from '../models/get-url-request.model';

@Injectable({
    providedIn: 'root'
})
export class TokenHandoffInitService {
    constructor(
        private authService: AuthService,
        private sessionStorageService: SessionStorageService
    ) {
    }

    /** Redeems a token_key before the router's initial navigation so AuthGuard sees the stored token. Never rejects. */
    public redeem(): Promise<void> {
        const url = new URL(window.location.href);
        const key = url.searchParams.get('token_key');

        if (!key) {
            return Promise.resolve();
        }

        url.searchParams.delete('token_key');
        window.history.replaceState({}, '', url.toString());

        return firstValueFrom(this.authService.redeemTokenHandoff(key)
            .pipe(
                timeout(10000),
                tap(tokens => {
                    if (tokens) {
                        this.authService.processWidgetB2cResponse(new RawB2cToken({
                            accessToken: tokens.accessToken,
                            refreshToken: tokens.refreshToken
                        }));
                        this.loadB2cUrls();
                    }
                }),
                map(() => undefined),
                catchError(() => of(undefined))
            ));
    }

    private loadB2cUrls(): void {
        this.authService.getB2CURLs(new GetUrlRequest({
            companyCode: this.sessionStorageService.getAuthToken()?.companyCode,
            domain: window.location.host
        }))
            .subscribe({
                next: urls => {
                    this.authService.b2cUrls = urls;
                    this.sessionStorageService.setItem('b2cURLs', JSON.stringify(urls));
                    this.sessionStorageService.setItem('b2CRefreshTokenBaseUrl', urls.b2CRefreshTokenBaseUrl);
                },
                error: () => { }
            });
    }
}
